module.exports = __webpack_public_path__ + "static/media/profile-background-small.3c68cfdf.jpg";